// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__38C5d","content":"LoadingAlert_content__3bXaS"};